<template>
  <div id="footer">
      <span>Copyright © 2021</span>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
#footer{
  background-color: rgb(19, 24, 39);
    padding: 1rem;
    width: 100%;
    text-align: center;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top:auto ;
    span{
        color: white;
    }
}
</style>